export function addWWW(url?: string) {
    if (!url) url = process.env.GATSBY_URL as string;

    // Create a new URL object to easily manipulate the URL
    const urlObj = new URL(url);

    // Check if the hostname already contains "www"
    if (!urlObj.hostname.startsWith("www.")) {
        // Prepend "www." to the hostname
        urlObj.hostname = "www." + urlObj.hostname;
    }

    // Return the updated URL as a string
    return urlObj.toString();
}